import { coreActions } from '@sonar-software/sonar-core';
import { LocalStorageKey } from '@sonar-software/sonar-ts-types';
import { SyncView } from './general';

import { Button, Space } from 'antd';
import { ONBOARDING_CONNECT_COPY, ONBOARDING_SYNC_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useOnboardingProgress, useOrganizations, useSwitchOrganization } from '@hooks';

export const SyncOrganizationView: React.FC = () => {
	const organizations = useOrganizations();
	const switchOrganization = useSwitchOrganization();
	const { progress, updateProgress } = useOnboardingProgress();

	const refreshOrgs = useAction(coreActions.requestGetCoreOrganizationsAll);

	const handleReturn = useCallback(() => {
		refreshOrgs();

		const lastUsedOrgId = localStorage.getItem(LocalStorageKey.LastUsedOrg);

		if (lastUsedOrgId && !isNaN(Number(lastUsedOrgId))) {
			localStorage.removeItem(LocalStorageKey.LastUsedOrg);
			switchOrganization({ organizationId: Number(lastUsedOrgId) });
		} else {
			const targetOrganizationId =
				progress?.organizationId ?? organizations?.filter((org) => org.hasSalesforceData)[ 0 ]?.id;

			switchOrganization({
				organizationId: targetOrganizationId
			});
		}

		updateProgress({
			isSalesforceConnected: true,
			isSalesforceSynced: true
		});
	}, [ organizations, progress?.organizationId, refreshOrgs, switchOrganization, updateProgress ]);

	return (
		<SyncView title={ ONBOARDING_SYNC_COPY.SYNCING_ORG }>
			<Space
				align='center'
				className='button-wrapper'>
				<Button
					onClick={ handleReturn }
					type='primary'>{ ONBOARDING_CONNECT_COPY.RETURN_TO_DASHBOARD }
				</Button>
			</Space>
		</SyncView>
	);
};
